import site from '@/api/project-mgt/site-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return site.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return site.store(data)
  },
  update(context, { id, data }) {
    return site.update(id, data)
  },
  destroy(context, id) {
    return site.destroy(id)
  },
  find(context, id) {
    return site.find(id)
  },
  viewCheckInOut(context, { id, params }) {
    return site.viewCheckInOut(id, { params })
  },
  formViewModel(context, attrubutes = {}) {
    return site.formViewModel({ params: attrubutes })
  }
}
